import { Routes } from '@angular/router';
import { CompanyComponent } from "./company.component";
import { EnterpriseSubscriptionComponent } from "../enterprise-subscription/enterprise-subscription.component";
import { PermissionGuard } from '../security/permission.guard';
import { CompanyGroupsPageComponent } from './company-groups-page.component';
import { CompanyGroupInvitationAcceptanceComponent } from './company-group-invitation-acceptance.component';
import { UsersAndRolesComponent } from './users-and-roles/users-and-roles.component';

export const companyRoutes: Routes = [
    {
        path: 'company',
        children: [
            {
                path: 'users-and-roles',
                component: UsersAndRolesComponent,
                canActivate: [PermissionGuard],
                data: { scope: 'ANY' }
            },
            {
                path: 'roles',
                redirectTo: 'users-and-roles',
                pathMatch: 'full'
            },
            {
                path: 'group-invitation/accept',
                component: CompanyGroupInvitationAcceptanceComponent
            },
            {
                path: 'groups',
                component: CompanyGroupsPageComponent,
                canActivate: [PermissionGuard],
                data: { scope: 'ANY' }
            },
            {
                path: '',
                component: CompanyComponent,
                canActivate: [PermissionGuard],
                data: { scope: 'ANY' }
            },
            {
                path: ':id',
                component: CompanyComponent,
                canActivate: [PermissionGuard],
                data: { scope: 'ANY' }
            }
        ]
    },
    {
        path: 'enterprise-subscription',
        component: EnterpriseSubscriptionComponent,
    },
    {
        path: 'enterprise-subscription/manage',
        component: EnterpriseSubscriptionComponent,
        data: { mode: 'management' }
    },
];
